import { Params } from '@angular/router';

export const generateAppRouteFromRedirectParams = (queryParams: Params): string => {
    const appUrl = getAppUrlFromRedirect(queryParams);
    const appQueryParams = getAppQueryParamsFromRedirect(queryParams);
    return `${appUrl}${appQueryParams}`;
};

export const getAppUrlFromRedirect = (queryParams: Params): string =>
    queryParams['appUrl'] ? queryParams['appUrl'] : queryParams['url'] ? queryParams['url'] : ``;

export const getAppQueryParamsFromRedirect = (queryParams: Params): string => {
    const appQueryParamsObject = filterAppUrlFromQueryParams(queryParams);
    const appQueryParamsString = transformToQueryParamsString(appQueryParamsObject);
    return appQueryParamsString;
};

export const filterAppUrlFromQueryParams = (queryParams: Params): Params =>
    Object.entries(queryParams).reduce(
        (acc, [key, val]) => ({
            ...acc,
            ...(key === 'appUrl' || key === 'url' ? undefined : { [key]: val }),
        }),
        {}
    );
export const transformToQueryParamsString = (queryParams: Params): string =>
    Object.entries(queryParams).reduce((acc, [key, val], i) => (i === 0 ? `?${key}=${val}` : `${acc}&${key}=${val}`), ``);
